import { styled, Box as MuiBox } from "@mui/material";
import { ContainerProps } from "./FloatingBar.props";

export const Container = styled((props: ContainerProps) => <MuiBox {...props} />, {
  shouldForwardProp: (prop) => prop !== "topOffset"
})(
  ({ theme: { breakpoints }, topOffset }) => `
    &.MuiBox-root {
      position: fixed;
      display: flex;
      flex-direction: row;
      gap: 16px;
      justify-content: space-between;
      align-items: center;
      top: ${topOffset + 88}px;
      margin: 0 16px;
      z-index: 1000;
      right: 0;

      ${breakpoints.up("sm")} {
        margin: 0 16px;
      }

      ${breakpoints.up("md")} {
        top: ${topOffset + 104}px;
        margin: 0 20px;
      }

      ${breakpoints.up("lg")} {
        margin: 0 32px;
      }
    }
  `
);
